export default __webpack_public_path__ + "static/media/official-stores.e4ef04b0.png";